import httpClient from './httpClient';

// Perfis do backoffice (os mesmos nomes que o core-backoffice coloca no JWT, um claim "role" por perfil).
export const ROLES = {
    editor: 'catalog-editor',
    consentEditor: 'catalog-consent-editor',
    approver: 'catalog-approver',
    userAdmin: 'user-admin'
};

export const ROLE_LABELS = {
    [ROLES.editor]: 'Editor',
    [ROLES.consentEditor]: 'Editor de consentimento',
    [ROLES.approver]: 'Aprovador',
    [ROLES.userAdmin]: 'Administrador de usuários'
};

const ROLE_CLAIM = 'http://schemas.microsoft.com/ws/2008/06/identity/claims/role';
const MUST_CHANGE_CLAIM = 'must-change-password';
const NAME_ID_CLAIM = 'http://schemas.xmlsoap.org/ws/2005/05/identity/claims/nameidentifier';

/**
 * Lê as claims do JWT SEM validar a assinatura. Serve só para decidir o que MOSTRAR (menu, botões): quem barra de verdade é o BFF e o
 * core-backoffice, que validam o token. Um token adulterado aqui só esconderia ou mostraria botões que o servidor recusa.
 */
export const decodeClaims = (token) => {
    try {
        const payload = token.split('.')[1].replace(/-/g, '+').replace(/_/g, '/');
        const padded = payload + '='.repeat((4 - (payload.length % 4)) % 4);
        // atob devolve bytes; o %XX + decodeURIComponent os lê como UTF-8 (acentos) sem depender de TextDecoder.
        const percent = Array.from(atob(padded), (c) => '%' + c.charCodeAt(0).toString(16).padStart(2, '0')).join('');
        return JSON.parse(decodeURIComponent(percent));
    } catch {
        return {};
    }
};

export const rolesFromToken = (token) => {
    if (!token) return [];
    const raw = decodeClaims(token)[ROLE_CLAIM];
    if (!raw) return [];
    return Array.isArray(raw) ? raw : [raw];
};

export const mustChangePasswordFromToken = (token) => !!token && decodeClaims(token)[MUST_CHANGE_CLAIM] !== undefined;

const storeToken = (token) => sessionStorage.setItem('backofficeToken', token);

export const login = async (username, password) => {
    const response = await httpClient.post('/auth/login', { username, password });
    storeToken(response.data.token);
    sessionStorage.setItem('backofficeUsername', response.data.username);
    return response.data;
};

/** Guarda o token renovado (perfis e pendência de senha vêm dentro dele). */
export const setToken = (token) => storeToken(token);

export const logout = () => {
    sessionStorage.removeItem('backofficeToken');
    sessionStorage.removeItem('backofficeUsername');
};

export const getToken = () => sessionStorage.getItem('backofficeToken');
export const getCurrentUsername = () => sessionStorage.getItem('backofficeUsername');
export const getCurrentUserId = () => decodeClaims(getToken())[NAME_ID_CLAIM] ?? null;
export const isAuthenticated = () => !!getToken();

export const getRoles = () => rolesFromToken(getToken());
export const hasRole = (role) => getRoles().includes(role);
export const mustChangePassword = () => mustChangePasswordFromToken(getToken());

// O que cada perfil enxerga (espelho das políticas do BFF).
export const isUserAdmin = () => hasRole(ROLES.userAdmin);
export const canEditCatalog = () => hasRole(ROLES.editor) || hasRole(ROLES.consentEditor);
export const canApproveCatalog = () => hasRole(ROLES.approver);
export const canSeeCatalog = () => canEditCatalog() || canApproveCatalog();

export const changeMyPassword = (currentPassword, newPassword) =>
    httpClient.post('/backoffice/users/me/password', { currentPassword, newPassword });
